<template>
  <div class="">
    <Breadcrumb :title="$t('miga.Home')" />
    <div class="row my-4">
      <div class="col-sm-6 mb-3">
        <router-link
          class="btn boton-izquierdo text-white pt-5"
          :to="{ name: 'SelectQueue' }"
        >
          <h2>
            <i class="fa fa-plus-circle fa-2x"></i>
            <br />
            <br />
            {{ $t("home.nuevatitulo") }}
          </h2>
          <p class="description align-middle" v-html="$t('home.nuevadesc')"></p>
        </router-link>
      </div>
      <div class="col-sm-6 mb-3">
        <router-link
          class="btn boton-derecho text-white pt-5"
          :to="{ name: 'MyTickets' }"
        >
          <h2>
            <i class="fa fa-calendar fa-2x"></i>
            <br />
            <br />
            {{ $t("home.miscitastitulo") }}
          </h2>
          <p
            class="description align-middle"
            v-html="$t('home.miscitasdesc')"
          />
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Utils from "@/services/Utils.js";
import Session from "@/session/Session.js";

import Breadcrumb from "@/components/Breadcrumb.vue";

export default {
  name: "Home",
  components: {
    Breadcrumb
  },
  props: {
    msg: String,
  },
  data: () => {
    return {
      Session,
    };
  },
  async mounted() {
    await Utils.initPortal(this, true);
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.boton-izquierdo {
  background-color: #37474f !important;
  width: 98%;
}
.boton-derecho {
  background-color: #19343e !important;
  width: 98%;
}

.description {
  height: 3.5rem !important;
}
</style>
